export default {
    'categories.activities': 'Aktiviteter',
    'categories.animals-nature': 'Djur & natur',
    'categories.custom': 'Anpassad',
    'categories.flags': 'Flagga',
    'categories.food-drink': 'Mat & dryck',
    'categories.objects': 'Objekt',
    'categories.people-body': 'Människor & kropp',
    'categories.recents': 'Nyligen använd',
    'categories.smileys-emotion': 'Humör & känslor',
    'categories.symbols': 'Symboler',
    'categories.travel-places': 'Resor & platser',
    'error.load': 'Det gick inte att ladda emojis',
    'recents.clear': 'Ta bort de senaste emojis',
    'recents.none': 'Du har inte valt några emojis än',
    'retry': 'Försök igen',
    'search.clear': 'Tom sökning',
    'search.error': 'Det gick inte att söka efter emojis',
    'search.notFound': 'Inga emojis hittades',
    'search': 'Sök efter emojis...'
  };
  